export default __webpack_public_path__ + "static/media/CL.c400dd4f.svg";